export const EcommerceSignalSubType = {
    OnlineRevenueChange: "OnlineRevenueChange",
    OnlineRevenueReached: "OnlineRevenueReached",
    OnlineTransactionsChange: "OnlineTransactionsChange",
    OnlineTransactionsReached: "OnlineTransactionsReached",
} as const;

export type EcommerceSignalSubType = (typeof EcommerceSignalSubType)[keyof typeof EcommerceSignalSubType];

export default EcommerceSignalSubType;
